import { render, staticRenderFns } from "./AccountRetentionPage.vue?vue&type=template&id=4219422f&scoped=true"
import script from "./AccountRetentionPage.vue?vue&type=script&lang=js"
export * from "./AccountRetentionPage.vue?vue&type=script&lang=js"
import style0 from "./AccountRetentionPage.vue?vue&type=style&index=0&id=4219422f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4219422f",
  null
  
)

export default component.exports